import * as process from 'process';

// Base URLs from .env
const BASE_URLS = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  SERVICES_BASE_URL: process.env.REACT_APP_SERVICES_BASE_URL,
  CAND_URL: process.env.REACT_APP_CAND_URL,
  STRAPI_BASE_URL: process.env.REACT_APP_STRAPI_BASE_URL,
} as const;

// API Paths
const API_PATHS = {
  // Core APIs
  CAND_CORE_API: '/core/api',
  COPILOT: '',

  // Platform APIs
  ADVISOR: '/advisor',
  ADVISOR_PLATFORM: '/advisorplatform',
  ORCHESTRATOR_POLICY_V2: '/orchestrator-policy-role/v2',
  MEETING: '/meetings',
  MARKET_PLATFORM: '/market-platform',
  DASHBOARDS: '/dashboard-platform',
  EDUCATION: '/education-platform',

  // Other APIs
  PBI: '',
  VOX: '',
  NETWORKING_API: '/networking/v1',
  FORMS: '/forms',
  NOTIFICATIONS_API: '/notifications',

  // Strapi APIs
  STRAPI_API: '/api',
} as const;

// URL Builder Function
export const buildApiUrl = (key: keyof typeof API_PATHS): string => {
  const baseUrl = (() => {
    switch (key) {
      case 'CAND_CORE_API':
      case 'COPILOT':
      case 'PBI':
      case 'VOX':
        return BASE_URLS.CAND_URL;
      case 'NETWORKING_API':
        return BASE_URLS.BASE_URL;
      case 'STRAPI_API':
        return BASE_URLS.STRAPI_BASE_URL;
      default:
        return BASE_URLS.BASE_URL;
    }
  })();

  if (!baseUrl) {
    throw new Error(`Base URL not found for API key: ${key}`);
  }

  return `${baseUrl}${API_PATHS[key]}`;
};

// Export all API URLs as constants
export const API_URLS = {
  // Core APIs
  CAND_CORE_API: buildApiUrl('CAND_CORE_API'),
  COPILOT: buildApiUrl('COPILOT'),
  NOTIFICATIONS_API: buildApiUrl('NOTIFICATIONS_API'),

  // Platform APIs
  ADVISOR: buildApiUrl('ADVISOR'),
  ADVISOR_PLATFORM: buildApiUrl('ADVISOR_PLATFORM'),
  ORCHESTRATOR_POLICY_V2: buildApiUrl('ORCHESTRATOR_POLICY_V2'),
  MEETING: buildApiUrl('MEETING'),
  MARKET_PLATFORM: buildApiUrl('MARKET_PLATFORM'),
  DASHBOARDS: buildApiUrl('DASHBOARDS'),
  EDUCATION: buildApiUrl('EDUCATION'),

  // Other APIs
  PBI: buildApiUrl('PBI'),
  VOX: buildApiUrl('VOX'),
  NETWORKING_API: buildApiUrl('NETWORKING_API'),
  FORMS: buildApiUrl('FORMS'),

  // Strapi APIs
  STRAPI_API: buildApiUrl('STRAPI_API'),
} as const;
